import React from 'react';
import styled from 'styled-components';

/**
 * Styled overlay component
 * Creates a semi-transparent backdrop for mobile menu
 */
const OverlayContainer = styled.div<{ $isOpen: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5); /* Semi-transparent black */
  z-index: 800; /* Below sidebar (900) but above main content */
  display: ${props => props.$isOpen ? 'block' : 'none'}; /* Show/hide based on state */
  
  /* Only show on mobile devices */
  @media (min-width: 769px) {
    display: none;
  }
`;

/**
 * Props interface for the Overlay component
 * Defines what data this component expects to receive
 */
interface OverlayProps {
  isOpen: boolean;           // Whether the overlay should be visible
  onClick: () => void;       // Function to call when overlay is clicked
}

/**
 * Overlay Component - Mobile menu backdrop
 * 
 * This component creates a dark overlay behind the mobile sidebar menu.
 * When users click on it, it closes the sidebar menu.
 * 
 * Key concepts:
 * - Conditional rendering: Only shows when isOpen is true
 * - Event handling: Responds to click events
 * - CSS positioning: Uses fixed positioning to cover entire screen
 * - Responsive design: Only visible on mobile devices
 */
const Overlay: React.FC<OverlayProps> = ({ isOpen, onClick }) => {
  return (
    <OverlayContainer 
      $isOpen={isOpen} 
      onClick={onClick}
    />
  );
};

export default Overlay; 